import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import {
  fetchGetInfrastructure,
  IGetInfrastructureResponse200,
  IGetInfrastructureResponse400,
} from '../../../repositories/newbuilding-card/v1/get-infrastructure';
import { IInfrastructureItem } from '../../../types/map';
import { ResponseError } from '../../../utils/errors';

export const getInfrastructureItems = async (newbuildingId: number): Promise<IInfrastructureItem[]> => {
  try {
    const response = await fetchGetInfrastructure<IGetInfrastructureResponse200, IGetInfrastructureResponse400>({
      httpApi: getHttpApi(),
      parameters: { newbuildingId },
      config: {
        requestConfig: { withCredentials: true },
      },
    });

    if (response.statusCode === 400) {
      const { message } = response.response;

      throw new ResponseError({
        domain: 'Map#getInfrastructureItems()',
        message,
      });
    }

    return response.response.infrastructure;
  } catch (error) {
    getLogger().error(error, {
      newbuildingId,
      domain: 'getStats',
    });

    return [];
  }
};
